import { containsSpecialAddressKeywordInLine1 } from '../validators/special-address-keywords';

/** Address section fields used to resolve AVS address line 2. */
export interface ValidateAddressLine2Source {
  streetAddress: string;
  suiteAptUnit: string;
  addressLine2?: string;
}

/**
 * Resolves the value sent as AVS addressLine2.
 * When line 1 is a special address, civic street comes from expanded address line 2,
 * with suite as fallback for return-address sections.
 */
export function resolveValidateAddressLine2(section: ValidateAddressLine2Source): string {
  const streetAddress = section.streetAddress.trim();
  const suiteAptUnit = section.suiteAptUnit.trim();
  const addressLine2 = section.addressLine2?.trim() ?? '';

  if (containsSpecialAddressKeywordInLine1(streetAddress)) {
    return addressLine2.length > 0 ? addressLine2 : suiteAptUnit;
  }

  return suiteAptUnit;
}
